import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-form-search-user',
  templateUrl: './form-search-user.component.html',
  styleUrls: ['./form-search-user.component.css']
})
export class FormSearchUserComponent {
  @Input() btnBuscarEnabled: boolean = false;
  @Output() emitSearch = new EventEmitter();
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {    
    this.form = this.formBuilder.group({
      nombreIdEmpleado: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  searchUserHandler() {
    if (this.form.valid) {
      const { nombreIdEmpleado } = this.form.value;
      this.emitSearch.emit(nombreIdEmpleado);
    }
  }
}
